import { render, staticRenderFns } from "./CourseSeoFields.vue?vue&type=template&id=c415135a&scoped=true&"
import script from "./CourseSeoFields.vue?vue&type=script&lang=js&"
export * from "./CourseSeoFields.vue?vue&type=script&lang=js&"
import style0 from "./CourseSeoFields.vue?vue&type=style&index=0&id=c415135a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c415135a",
  null
  
)

export default component.exports